import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Popover } from '@mui/material'
import { LogoutRounded, ManageAccountsOutlined } from '@mui/icons-material'
import { useDispatch, useSelector } from '../../store'
import { signOut } from '../../store/auth/actionCreator'
import { useAdminTheme } from '../../hook/useAdminTheme'
import l from '../../page/SubscribersPageV2.module.css'
import h from './HeaderV2.module.css'

/*
 * The signed-in admin in the v2 header: the avatar (or the initials) and a
 * menu — who it is, edit the profile, log out. The same actions as the
 * classic Profile, which the classic pages keep.
 */

export function ProfileV2() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { theme } = useAdminTheme()
  const user = useSelector((state) => state.settings)
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null)

  const name = [user.firstname, user.lastname].filter(Boolean).join(' ')
  const initials = (name || user.email || '?').split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((x) => x[0]?.toUpperCase()).join('')
  const face = user.avatar ? <img src={user.avatar} alt="" /> : <span className={h.initials}>{initials}</span>

  return (
    <>
      <button type="button" className={`${h.btn} ${h.avatarBtn} ${anchor ? h.btnOn : ''}`} onClick={(e) => setAnchor(e.currentTarget)} aria-label="Profile" title={name || user.email}>
        {face}
      </button>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { background: 'transparent', boxShadow: 'none', overflow: 'visible' } }}
      >
        <div className={`${l.theme} ${h.panel} ${h.menu}`} data-theme={theme}>
          <div className={h.who}>
            <span className={`${h.btn} ${h.avatarBtn}`}>{face}</span>
            <div className={h.whoText}>
              <b>{name || user.email}</b>
              {name && <span>{user.email}</span>}
              {user.role && <em className={h.role}>{user.role.toLowerCase()}</em>}
            </div>
          </div>
          <button type="button" className={h.menuItem} onClick={() => { setAnchor(null); navigate('/settings') }}>
            <ManageAccountsOutlined sx={{ fontSize: 18 }} />{t('header.editProfile')}
          </button>
          <div className={h.sep} />
          <button type="button" className={`${h.menuItem} ${h.danger}`} onClick={() => { setAnchor(null); dispatch(signOut(navigate)) }}>
            <LogoutRounded sx={{ fontSize: 18 }} />{t('header.logout')}
          </button>
        </div>
      </Popover>
    </>
  )
}
